<div class="master-form">


    <div class="card-header card-primary text-sm-center  text-center" style="color:black">
        {{'ADDMOREGROUPS' | translate}}
    </div>
    <br>
    <!--search area-->
    <div class="ui-widget-header search-area row">
        <div class="col-5">
            <input class="form-control" id="myInput" #box (keyup)="onKeyUp(box.value)" type="text" pInputText size="30" placeholder="{{ 'FILTER' | translate }}">
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-sm-4">
            <div class="form-check">
                <label>
          <input type="checkbox" id="all" (click)="toggleAll()" />
          <span for="all" [ngClass]="{'text-primary':allChecked}">
            <b>{{'SELECTALL' | translate}}</b>
          </span>
        </label>
            </div>
        </div>

        <div class="col-sm-4" *ngFor="let group of groupsArray;let i=index">
            <div class="form-check">
                <label [attr.for]="i">
          <input type="checkbox" [id]="i" [(ngModel)]="group.selected" (click)="selectedgroups(group)" />
          <span>
            {{translate.currentLang == 'ar'? group.nameAr: group.nameEn}}
          </span>
        </label>
            </div>
        </div>
    </div>
</div>